import Container from "../../components/ui/container";
import { Facebook, Twitter, Linkedin, Mail, Phone, MapPin  } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-gray-50 py-12">
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">OutsourceHub</h3>
            <p className="text-sm text-muted-foreground">
              Connecting businesses with exceptional remote talent while reducing costs.
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#benefits" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Why Choose Us
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Services
                </a>
              </li>
              <li>
                <a  onClick={(e) => {
    e.preventDefault(); // Prevent default jump behavior
    document.getElementById("forms")?.scrollIntoView({ behavior: "smooth" });
  }} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Apply as Talent
                </a>
              </li>
              <li>
                <a onClick={(e) => {
    e.preventDefault(); // Prevent default jump behavior
    document.getElementById("forms")?.scrollIntoView({ behavior: "smooth" });
  }} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Hire Talent
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <ul className="space-y-2">
                <li className="flex items-center text-sm text-muted-foreground">
                <MapPin className="h-4 w-4 mr-2" />
                111 Peter St, 9th Floor, Suite 902, Toronto, Canada
              </li>
              <li className="flex items-center text-sm text-muted-foreground">
                <Mail className="h-4 w-4 mr-2" />
                contact@outsourcehub.com
              </li>
              <li className="flex items-center text-sm text-muted-foreground">
                <Phone className="h-4 w-4 mr-2" />
                +1 (674) 518-9514
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Follow Us</h4>
            <div className="flex space-x-4">
              <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t flex justify-between text-sm text-muted-foreground">
  <div>
    <p>&copy; {new Date().getFullYear()} OutsourceHub. All rights reserved.</p>
  </div>
  <div>
      A Product of{" "}
      <a href="https://koralbyte.com/" target="_blank" rel="noopener noreferrer" className=" hover:underline cursor-pointer ">
        Koralbyte
      </a>
  </div>
</div>

      </Container>
    </footer>
  );
}
